<div class="legend-container">
    <div *ngFor="let key of getKeys()" class="legend-item">
      <span class="legend-circle" [ngStyle]="getBackgroundColor(key)"></span>
      <span class="legend-label">
        {{key}}
      </span>
    </div>
  </div>